<mat-drawer-container class="admin-container" autosize>
    <mat-drawer fxHide.lt-md #drawer class="admin-sidenav" mode="side" opened>
        <mat-nav-list>
            <a mat-list-item [routerLink]="'users'" routerLinkActive="selected-nav" i18n="@@users-title">Users</a>
            <a mat-list-item [routerLink]="'groups'" routerLinkActive="selected-nav" i18n="@@groups">Groups</a>
            <a mat-list-item [routerLink]="'learner-resources'" routerLinkActive="selected-nav" i18n="@@learner-resources">Learner resources</a>
            <a mat-list-item [routerLink]="'reports'" routerLinkActive="selected-nav" i18n="@@reporters">Reports</a>
            <a mat-list-item name="organisation-and-centre" [routerLink]="'organisation-and-centre'"
                routerLinkActive="selected-nav" *ngIf="ifCurrentUserIsSystemAdmin"
                i18n="@@organisation-and-centre">Organisation and Centre</a>
        </mat-nav-list>
    </mat-drawer>

    <div class="admin-sidenav-content">
        <router-outlet></router-outlet>
    </div>
</mat-drawer-container>